import React, { useEffect, useState } from 'react';
import { Alert, Spacer } from '@guildeducationinc/recess';
import { formatNumberToWord } from '@src/utilities/format';
import { openNextStepsMicrositeForInstitution } from '@src/utilities/nextStepsUtility';
import { getAcademicPartnerUuid, getAcademicPartnerName } from '@src/utilities/applicationUtility';
import { Application } from '@src/hooks/useApplications';
import { clickable } from '@src/analytics';

interface NextStepToastProps {
  applications: Application[];
  applicationsUrl: string;
  status: 'completed' | 'approved';
}

export const NextStepsToast: React.FC<NextStepToastProps> = ({
  applications,
  applicationsUrl,
  status,
}) => {
  const [displayToast, setDisplayToast] = useState(true);
  const [completedAppNextStepsToastDisplay, setCompletedAppNextStepsToastDisplay] = useState(true);

  useEffect(() => {
    if (applications.length === 0) {
      setDisplayToast(false);
    }
  }, [applications]);

  const getCompletedApplicationContent = () => {
    const firstCompletedApp = applications[0];
    const firstCompletedAppInstitutionName = firstCompletedApp
      ? getAcademicPartnerName(applications[0])
      : '';

    return applications.length > 1
      ? "We received your applications. See what's next if you're approved."
      : `We received your application to ${firstCompletedAppInstitutionName}. See what's next if you're approved.`;
  };

  const getApprovedApplicationContent = () => {
    if (applications.length > 1) {
      const wordNumber = formatNumberToWord(applications.length, 3);
      return `Congrats! We've approved ${wordNumber} of your Guild applications. See what's next in the application process.`;
    }

    const firstApprovedApplication = applications[0];
    return `Congrats! We've approved your Guild application to ${getAcademicPartnerName(
      firstApprovedApplication
    )}. See what's next in the application process.`;
  };

  const toastContent =
    status === 'completed' ? getCompletedApplicationContent() : getApprovedApplicationContent();
  const toastActionHref = applications.length > 1 ? applicationsUrl : undefined;
  const toastActionContent = applications.length > 1 ? "See what's next" : 'Explore next steps';
  const trackingPrefix = applications.length > 1 ? 'multiple' : 'single';

  return completedAppNextStepsToastDisplay ? (
    <Spacer pb={32}>
      <Alert
        display={displayToast}
        handleToastClose={() => {
          clickable({
            product: 'home',
            loggedIn: true,
            tag: `${trackingPrefix}_explore_next_steps`,
            text: 'close',
            type: 'action icon',
          });
          setCompletedAppNextStepsToastDisplay(false);
        }}
        type='success'
      >
        <Alert.Content>{toastContent}</Alert.Content>
        <Alert.Action
          className='cursor--pointer'
          href={toastActionHref}
          onClick={() => {
            clickable({
              product: 'home',
              loggedIn: true,
              tag: `${trackingPrefix}_explore_next_steps`,
              text: 'Explore_next_steps',
              type: 'link',
            });

            if (applications.length === 1) {
              const institutionId = getAcademicPartnerUuid(applications[0]);
              openNextStepsMicrositeForInstitution(institutionId);
            }
          }}
        >
          {toastActionContent}
        </Alert.Action>
      </Alert>
    </Spacer>
  ) : null;
};
